/* Sagex header extras: smart scroll, gold progress line, search, refined icons, richer menu drawer */
(function () {
  if (window.__sgxHeader) return;
  window.__sgxHeader = true;

  var css = `
  body .sgx-header{padding-top:calc(var(--sgx-pt,10px) + env(safe-area-inset-top,0px));padding-bottom:var(--sgx-pb,10px);transition:top .45s cubic-bezier(.2,.7,.2,1),padding .35s ease}
  body .sgx-header::before{content:'';position:absolute;inset:0;z-index:-1;background:linear-gradient(180deg,rgba(5,5,5,.74),rgba(5,5,5,.52));-webkit-backdrop-filter:blur(16px) saturate(140%);backdrop-filter:blur(16px) saturate(140%);border-bottom:1px solid rgba(217,201,163,.16);opacity:0;transition:opacity .4s ease;pointer-events:none}
  body .sgx-header::after{content:'';position:absolute;left:0;bottom:0;height:2px;width:calc(var(--sgx-p,0) * 100%);background:linear-gradient(90deg,#b9a679,#d9c9a3 60%,#fff2cf);opacity:0;transition:opacity .3s ease;pointer-events:none}
  body .sgx-header.sgx-scrolled::before,body .sgx-header.sgx-scrolled::after{opacity:1}
  body .sgx-header.sgx-scrolled{padding-top:calc(var(--sgx-pt,10px) * .6 + env(safe-area-inset-top,0px));padding-bottom:calc(var(--sgx-pb,10px) * .6)}
  body .sgx-header.sgx-hide{top:-130px}

  body .sgx-header [class*='header-icon-']{transition:transform .3s cubic-bezier(.2,.7,.2,1),border-color .3s ease,box-shadow .3s ease,background .3s ease}
  body .sgx-header [class*='header-icon-']:active{transform:scale(.92)}
  body .sgx-header :focus-visible{outline:1px solid #d9c9a3;outline-offset:3px}
  @media (hover:hover){
    body .sgx-header [class*='header-icon-']:hover{border-color:rgba(217,201,163,.65);background:rgba(217,201,163,.12)}
  }
  body .sgx-header [class*='header-logo-'] img{transition:transform .35s ease,opacity .3s ease}
  body .sgx-header.sgx-scrolled [class*='header-logo-'] img{transform:scale(.9)}

  body .sgx-header [data-cart-count]{background:#d9c9a3;color:#050505;font-weight:700;width:auto;min-width:17px;height:17px;padding:0 4px;border-radius:9px;top:-5px;right:-6px;box-shadow:0 0 0 2px rgba(5,5,5,.9);transition:transform .3s ease,opacity .3s ease}
  body .sgx-header [data-cart-count].sgx-zero{opacity:0;transform:scale(.4)}
  body .sgx-header [data-cart-count].sgx-pop{animation:sgxPop .55s cubic-bezier(.2,.9,.3,1.4)}
  @keyframes sgxPop{0%{transform:scale(1)}40%{transform:scale(1.5)}100%{transform:scale(1)}}

  body .sgx-header [data-menu-drawer]{border-right-color:rgba(217,201,163,.2)}
  body .sgx-header [class*='menu-content-']{counter-reset:sgx;padding-top:8px}
  body .sgx-header.sgx-ready [class*='menu-item-']{opacity:0;transform:translateX(-14px)}
  body .sgx-header.sgx-ready [data-menu-drawer].active [class*='menu-item-']{animation:sgxIn .55s cubic-bezier(.2,.7,.2,1) forwards;animation-delay:calc(var(--i,0) * 70ms + 120ms)}
  @keyframes sgxIn{to{opacity:1;transform:none}}
  body .sgx-header [class*='menu-item-'] a{display:flex;align-items:baseline;gap:14px;letter-spacing:.14em;text-transform:uppercase;transition:transform .35s cubic-bezier(.2,.7,.2,1),color .3s ease}
  body .sgx-header [class*='menu-item-'] a::before{counter-increment:sgx;content:counter(sgx,decimal-leading-zero);font-size:10px;letter-spacing:.12em;color:#d9c9a3;opacity:.85}
  body .sgx-header [class*='menu-item-'].sgx-current a{color:#d9c9a3}
  @media (hover:hover){body .sgx-header [class*='menu-item-'] a:hover{transform:translateX(6px);color:#d9c9a3}}
  .sgx-drawer-search{display:flex;align-items:center;gap:12px;width:calc(100% - 40px);margin:18px 20px 4px;padding:12px 16px;border-radius:999px;border:1px solid rgba(217,201,163,.3);background:rgba(255,255,255,.05);color:rgba(255,255,255,.6);font:inherit;font-size:12px;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}
  .sgx-drawer-search svg{width:16px;height:16px;stroke:#d9c9a3;flex:none}
  .sgx-foot{margin:26px 20px 30px;padding-top:18px;border-top:1px solid rgba(217,201,163,.2);font-size:10px;letter-spacing:.2em;text-transform:uppercase;color:rgba(255,255,255,.55);line-height:2.1}
  .sgx-foot b{color:#d9c9a3;font-weight:500;margin-right:8px}

  .sgx-search{position:fixed;inset:0;z-index:1001;display:flex;flex-direction:column;background:rgba(5,5,5,.94);-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px);opacity:0;visibility:hidden;transition:opacity .35s ease,visibility .35s ease;color:#fff}
  .sgx-search.open{opacity:1;visibility:visible}
  .sgx-s-top{display:flex;align-items:center;gap:14px;width:100%;max-width:720px;margin:0 auto;padding:calc(20px + env(safe-area-inset-top,0px)) 20px 12px}
  .sgx-s-field{flex:1;display:flex;align-items:center;gap:12px;padding-bottom:10px;border-bottom:1px solid rgba(217,201,163,.5)}
  .sgx-s-field svg{width:20px;height:20px;stroke:#d9c9a3;flex:none}
  .sgx-s-field input{flex:1;min-width:0;background:transparent;border:0;outline:0;box-shadow:none;color:#fff;font-size:18px;letter-spacing:.06em;padding:0;-webkit-appearance:none;appearance:none}
  .sgx-s-field input::placeholder{color:rgba(255,255,255,.4)}
  .sgx-s-close{width:36px;height:36px;flex:none;border-radius:50%;border:1px solid rgba(217,201,163,.4);background:rgba(255,255,255,.06);color:#d9c9a3;font-size:22px;line-height:32px;padding:0;cursor:pointer}
  .sgx-s-body{flex:1;overflow-y:auto;width:100%;max-width:720px;margin:0 auto;padding:10px 20px 40px}
  .sgx-s-label{margin:18px 0 12px;font-size:10px;letter-spacing:.22em;text-transform:uppercase;color:rgba(255,255,255,.45)}
  .sgx-s-chips{display:flex;flex-wrap:wrap;gap:10px}
  .sgx-s-chip{padding:9px 16px;border-radius:999px;border:1px solid rgba(217,201,163,.4);color:#d9c9a3;font-size:11px;letter-spacing:.14em;text-transform:uppercase;text-decoration:none}
  .sgx-s-row{display:flex;align-items:center;gap:14px;padding:12px 0;border-bottom:1px solid rgba(255,255,255,.08);text-decoration:none;color:#fff}
  .sgx-s-row img{width:56px;height:70px;object-fit:cover;border-radius:4px;background:rgba(255,255,255,.06);flex:none}
  .sgx-s-row span{display:block}
  .sgx-s-title{font-size:12px;letter-spacing:.12em;text-transform:uppercase;line-height:1.5}
  .sgx-s-price{margin-top:4px;font-size:13px;letter-spacing:.08em;color:#d9c9a3}
  .sgx-s-all{display:inline-block;margin-top:22px;padding-bottom:4px;border-bottom:1px solid #d9c9a3;color:#d9c9a3;font-size:11px;letter-spacing:.18em;text-transform:uppercase;text-decoration:none}
  .sgx-s-empty{padding:28px 0;color:rgba(255,255,255,.6);font-size:13px;letter-spacing:.08em}

  @media (prefers-reduced-motion:reduce){
    body .sgx-header,body .sgx-header::before{transition:none}
    body .sgx-header.sgx-ready [class*='menu-item-']{opacity:1;transform:none;animation:none!important}
    body .sgx-header [data-cart-count].sgx-pop{animation:none}
  }
  `;
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var header = document.querySelector(`[class^='ai-mobile-header-']`);
    if (!header) return;
    header.classList.add('sgx-header');

    var cs = getComputedStyle(header);
    header.style.setProperty('--sgx-pt', cs.paddingTop);
    header.style.setProperty('--sgx-pb', cs.paddingBottom);

    var drawer = header.querySelector('[data-menu-drawer]');
    var menuBtn = header.querySelector('[data-menu-trigger]');
    var menuClose = header.querySelector('[data-menu-close]');
    var badge = header.querySelector('[data-cart-count]');
    var account = header.querySelector(`a[href='/account']`);

    function closeMenu() {
      if (drawer && drawer.classList.contains('active') && menuClose) menuClose.click();
    }

    /* ---- smart scroll: frosted bar, progress line, hide on scroll down ---- */
    var last = window.scrollY || 0;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.max(0, window.scrollY || 0);
        header.classList.toggle('sgx-scrolled', y > 20);
        var total = document.documentElement.scrollHeight - window.innerHeight;
        header.style.setProperty('--sgx-p', total > 0 ? Math.min(1, y / total) : 0);
        var locked = document.body.style.overflow === 'hidden';
        if (!locked) {
          if (y > last + 6 && y > 120) header.classList.add('sgx-hide');
          else if (y < last - 6 || y <= 120) header.classList.remove('sgx-hide');
        }
        last = y;
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- cart badge: hide at zero, pop on change ---- */
    if (badge) {
      var sync = function () {
        badge.classList.toggle('sgx-zero', (parseInt(badge.textContent, 10) || 0) === 0);
      };
      sync();
      new MutationObserver(function () {
        sync();
        badge.classList.remove('sgx-pop');
        void badge.offsetWidth;
        badge.classList.add('sgx-pop');
      }).observe(badge, { childList: true, characterData: true, subtree: true });
    }

    /* ---- menu drawer: staggered links, current page, footer, swipe to close ---- */
    if (drawer) {
      var items = drawer.querySelectorAll(`[class*='menu-item-']`);
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--i', i);
        var a = items[i].querySelector('a');
        if (a) {
          try {
            if (new URL(a.href, location.origin).pathname === location.pathname) items[i].classList.add('sgx-current');
          } catch (e) {}
        }
      }
      var foot = document.createElement('div');
      foot.className = 'sgx-foot';
      foot.innerHTML = `<div><b>&#9670;</b>Free shipping across India</div><div><b>&#9670;</b>Easy returns &amp; exchanges</div>`;
      drawer.appendChild(foot);

      var tx = 0, ty = 0, tracking = false;
      drawer.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        tx = t.clientX;
        ty = t.clientY;
        tracking = true;
      }, { passive: true });
      drawer.addEventListener('touchmove', function (e) {
        if (!tracking) return;
        var t = e.touches[0];
        if (t.clientX - tx < -70 && Math.abs(t.clientY - ty) < 40) {
          tracking = false;
          closeMenu();
        }
      }, { passive: true });
      drawer.addEventListener('touchend', function () { tracking = false; });
    }
    header.classList.add('sgx-ready');

    /* ---- search overlay ---- */
    var svgSearch = `<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'><path stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z'/></svg>`;
    var ov = document.createElement('div');
    ov.className = 'sgx-search';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-label', 'Search');
    ov.innerHTML = `<div class='sgx-s-top'><label class='sgx-s-field'>` + svgSearch + `<input type='search' placeholder='Search the collection' autocomplete='off' autocapitalize='off' spellcheck='false' enterkeyhint='search'></label><button type='button' class='sgx-s-close' aria-label='Close search'>&times;</button></div><div class='sgx-s-body'></div>`;
    document.body.appendChild(ov);
    var input = ov.querySelector('input');
    var body = ov.querySelector('.sgx-s-body');
    var token = 0;
    var timer = null;

    function clear(n) { while (n.firstChild) n.removeChild(n.firstChild); }
    function label(text) {
      var d = document.createElement('div');
      d.className = 'sgx-s-label';
      d.textContent = text;
      return d;
    }
    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      try {
        return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
          maximumFractionDigits: 0
        }).format(n);
      } catch (e) { return '₹' + Math.round(n); }
    }
    function showBrowse() {
      clear(body);
      var links = drawer ? [].slice.call(drawer.querySelectorAll('a')) : [];
      if (!links.length) return;
      body.appendChild(label('Browse'));
      var wrap = document.createElement('div');
      wrap.className = 'sgx-s-chips';
      links.forEach(function (l) {
        var c = document.createElement('a');
        c.className = 'sgx-s-chip';
        c.href = l.href;
        c.textContent = (l.textContent || '').trim();
        wrap.appendChild(c);
      });
      body.appendChild(wrap);
    }
    function viewAll(q) {
      var all = document.createElement('a');
      all.className = 'sgx-s-all';
      all.href = '/search?q=' + encodeURIComponent(q);
      all.textContent = 'View all results';
      return all;
    }
    function run(q) {
      var my = ++token;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (my !== token) return;
          var list = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          clear(body);
          if (!list.length) {
            var e = document.createElement('div');
            e.className = 'sgx-s-empty';
            e.textContent = 'No matches for “' + q + '”';
            body.appendChild(e);
            return;
          }
          body.appendChild(label('Products'));
          list.forEach(function (p) {
            var row = document.createElement('a');
            row.className = 'sgx-s-row';
            row.href = p.url;
            var u = p.featured_image && p.featured_image.url;
            if (u) {
              var im = document.createElement('img');
              im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=140';
              im.alt = '';
              im.loading = 'lazy';
              row.appendChild(im);
            }
            var meta = document.createElement('span');
            var t = document.createElement('span');
            t.className = 'sgx-s-title';
            t.textContent = p.title;
            var pr = document.createElement('span');
            pr.className = 'sgx-s-price';
            pr.textContent = money(p.price);
            meta.appendChild(t);
            meta.appendChild(pr);
            row.appendChild(meta);
            body.appendChild(row);
          });
          body.appendChild(viewAll(q));
        })
        .catch(function () {
          if (my !== token) return;
          clear(body);
          body.appendChild(viewAll(q));
        });
    }
    function openSearch() {
      closeMenu();
      ov.classList.add('open');
      document.body.style.overflow = 'hidden';
      showBrowse();
      setTimeout(function () { input.focus(); }, 150);
    }
    function closeSearch() {
      ov.classList.remove('open');
      document.body.style.overflow = '';
      input.blur();
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { token++; showBrowse(); return; }
      timer = setTimeout(function () { run(q); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(input.value.trim());
      }
    });
    ov.querySelector('.sgx-s-close').addEventListener('click', closeSearch);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeSearch(); });

    /* search button in the header (next to the menu button) */
    if (menuBtn) {
      var sBtn = document.createElement('button');
      sBtn.type = 'button';
      sBtn.className = account ? account.className : menuBtn.className;
      sBtn.setAttribute('aria-label', 'Search');
      sBtn.innerHTML = svgSearch;
      menuBtn.parentNode.insertBefore(sBtn, menuBtn.nextSibling);
      sBtn.addEventListener('click', openSearch);
    }
    /* search shortcut inside the menu drawer */
    if (drawer) {
      var dBtn = document.createElement('button');
      dBtn.type = 'button';
      dBtn.className = 'sgx-drawer-search';
      dBtn.innerHTML = svgSearch + '<span>Search products</span>';
      var mc = drawer.querySelector(`[class*='menu-content-']`);
      drawer.insertBefore(dBtn, mc || null);
      dBtn.addEventListener('click', openSearch);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (ov.classList.contains('open')) closeSearch();
      else closeMenu();
    });
  });
})();
